// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__edJyf","left":"StickyBox_left__1qG0P","right":"StickyBox_right__2wjbw"};